import { BaseResource } from 'utils/ApiUtils';

export default class ProjectIRConfiguration extends BaseResource {
    constructor(args, attr = ProjectIRConfiguration.attributes) {
        super(args, attr)
    }

    static columns = [
        { title: "Configuration", field: "label" },
        { title: "Level", field: "level" },
        { title: "Values", field: "value" },
        { title: "name", field: "name" },
    ]

    static attributes = ProjectIRConfiguration.columns.map(r => r.field)

    static expand = []
}